export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8935.43c4a55a.jpg";